import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Copy, ExternalLink, Globe, Settings as SettingsIcon } from 'lucide-react';
import { toast } from 'sonner';

import DashboardLayout from '@/components/DashboardLayout';
import Breadcrumbs from '@/components/navigation/Breadcrumbs';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const PublicBookingLinkPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const link = `${window.location.origin}/book/${user?.organization_id}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success('Link gekopieerd');
    } catch (error) {
      toast.error('Kon de link niet kopiëren');
    }
  };

  return (
    <DashboardLayout>
      <div className="space-y-6" data-testid="public-booking-link-page">
        <Breadcrumbs items={[{ label: 'Reserveringen', href: '/bookings' }, { label: 'Publieke boekingspagina' }]} />
        <div>
          <h1 className="text-2xl font-bold text-slate-900 font-['Manrope']">Publieke boekingspagina</h1>
          <p className="mt-1 text-slate-500">Deel deze link met klanten voor online reserveren.</p>
        </div>
        <Card className="border-0 shadow-sm">
          <CardContent className="space-y-4 p-5">
            <div className="flex items-center gap-2 rounded-xl bg-teal-50 p-3 text-teal-700">
              <Globe className="h-4 w-4 shrink-0" />
              <span className="break-all font-mono text-sm">{link}</span>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button className="rounded-xl bg-teal-600 text-white hover:bg-teal-700" onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}>
                <ExternalLink className="mr-2 h-4 w-4" /> Pagina openen
              </Button>
              <Button variant="outline" className="rounded-xl" onClick={copyLink}>
                <Copy className="mr-2 h-4 w-4" /> Link kopiëren
              </Button>
              <Button variant="ghost" className="rounded-xl" onClick={() => navigate('/settings')}>
                <SettingsIcon className="mr-2 h-4 w-4" /> Naar instellingen
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default PublicBookingLinkPage;
